import React, { Component } from 'react';
import ScreenContainer from '../ui/ScreenContainer';
import BasicPageComponent from '../BasicPageComponent';
import * as Actions from '../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import LinearProgress from '@mui/material/LinearProgress';

class CheckOver extends Component {
    constructor(props) {
      super(props);
      this.state = {
        progress:0
      };
    }

    componentDidMount() {
    }

    render() {
      const{progress}=this.state;

        // setInterval(() => {
        //   const state = this.state;
        //   if (state.progress > 3000) {
        //     window.location = process.env.REACT_APP_LOGIN_URL;
        //   }

        //   this.setState({ progress: state.progress + 1000 });
        // }, 1000);
        window.location = process.env.REACT_APP_LOGIN_URL;

      return (
        <div>
          {/* <div style = {{display: 'flex',
            flexDirection: 'column'}}>
            <BasicPageComponent
              children = {
                <ScreenContainer>
                  
                  <div>{1==1 ?
                  <div style={{maxWidth: 500}} className='divcenter'>
                    <h3 style={{fontFamily:'Gilroy',color:'#28a5ad',margin:'auto'}}>Kullanıcı Giriş Ekranına Yönlendiriliyorsunuz</h3>
                    <br />
                    <LinearProgress/>
                    <br />
                    <LinearProgress/>
                  </div> :
                  null }</div>
              </ScreenContainer>
              }
            />       
          </div> */}
        </div>
      );
    }
  }

  const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
  });

  export default compose(
    connect(
      null,
      mapDispatchToProps
    )
  )(CheckOver);